/**
 * Poisson
 * -------
 * 
 * June 2026
 */
import { InputNumber } from "primereact/inputnumber";

/**
 * Distribution component for editing the parameters of a Poisson distribution.
 * 
 * @param {String} elementType      - Type of element tied to distribution. (actions, resources, entity_types)
 * @param {Object} element          - Attributes for an element being edited.
 * @param {Object} attr             - Distribution parameters tied with element attribute.
 * @param {Function} distUpdater    - Sets which distribution is currently being used.
 * @param {Function} warningUpdater - Updates warnings for an element parameter.
 * @param {Object} configWarnings   - Verification warnings for model elements.
 */
function Poisson({ elementType, element, attr, distUpdater, warningUpdater, configWarnings }) {
    const poissonWarnings = {
        'lambda': function(newLambda) { return newLambda <= 0 ? `${attr} - Lambda value must be positive` : null }
    }

    /**
     * Updates the Poisson distribution's lambda parameter for an attribute.
     * 
     * @param {float} newLambda - Updated value for the Poisson distribution's lambda.
     */
    const handlePoisson = (newLambda) => {
        warningUpdater(element.gid, attr, poissonWarnings['lambda'](newLambda));

        const newPoisson = {...element[attr].attr, lambda: newLambda};
        const newDist = {...element[attr], attr: newPoisson};
        console.log("New Poisson distribution: ", newPoisson);
        distUpdater(attr, newDist);
    }

    return (
        <div>
            <label style={{ marginRight: '0.5rem' }}>Lambda (Rate Parameter):</label>
            <InputNumber value={element[attr].attr.lambda} onValueChange={(event) => handlePoisson(event.target.value)} maxFractionDigits={2} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
        </div>
    )
}

export default Poisson;